<template>
  <div class="slds-form-element slds-dropdown-trigger slds-dropdown-trigger_click slds-is-open">
    <div class="slds-datepicker slds-dropdown_left" role="dialog">
      <div class="slds-datepicker__filter slds-grid">
        <div class="slds-datepicker__filter_month slds-grid slds-grid_align-spread slds-grow">
          <div class="slds-align-middle">
            <button
              class="slds-button slds-button_icon slds-button_icon-container"
              :disabled="disabled"
              :title="$t('general.previous')"
              @click="addMonths(-1)">
              <svg class="slds-button__icon" aria-hidden="true">
                <use xlink:href="../../assets/symbols.svg#left" />
              </svg>
            </button>
          </div>
          <h2 aria-atomic="true" aria-live="assertive" class="slds-align-middle" id="month">
            {{$t(`months[${viewing.month}]`)}}
          </h2>
          <div class="slds-align-middle">
            <button
              class="slds-button slds-button_icon slds-button_icon-container"
              :disabled="disabled"
              :title="$t('general.next')"
              @click="addMonths(1)">
              <svg class="slds-button__icon" aria-hidden="true">
                <use xlink:href="../../assets/symbols.svg#right" />
              </svg>
            </button>
          </div>
        </div>
        <div class="slds-shrink-none">
          <div class="slds-select_container">
            <select class="slds-select" id="select-01" v-model="viewing.year" :disabled="disabled">
              <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
            </select>
          </div>
        </div>
      </div>
      <table
        aria-labelledby="month"
        aria-multiselectable="true"
        class="slds-datepicker__month"
        role="grid">
        <thead>
          <tr id="weekdays">
            <th v-for="n in 7" :key="n" :id="$t(`days.long[${n - 1}]`)" scope="col">
              <abbr :title="$t(`days.long[${n - 1}]`)">{{ $t(`days.short[${n - 1}]`) }}</abbr>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(week, index) in calendar" :key="index">
            <td
              role="gridcell"
              v-for="day in week.days"
              @click="goToDate(day)"
              :key="day.day()"
              :class="getClasses(day)">
              <span @click="selectDay(day.date())" class="slds-day">{{ day.date() }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="slds-button slds-align_absolute-center slds-text-link" @click="today" :disabled="disabled">
        {{ $t('executionRules.exclusionRules.today') }}
      </button>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
export default {
  computed: {
    momentObject () {
      return moment(`${this.viewing.year}-${this.viewing.month + 1}-${this.viewing.day}`, 'YYYY-MM-DD')
    },
    calendar () {
      moment.locale(this.$store.getters['session/locale'])
      let calendar = []
      const startDay = this.momentObject.clone().startOf('month').startOf('week')
      const endDay = this.momentObject.clone().endOf('month').endOf('week')

      let date = startDay.clone().subtract(1, 'day')

      while (date.isBefore(endDay, 'day')) {
        calendar.push({
          days: Array(7).fill(0).map(() => date.add(1, 'day').clone())
        })
      }

      return calendar
    }

  },
  created () {
    const now = moment()
    const currentYear = now.year()
    _.range(-5, 0, 1)
      .concat(_.range(5))
      .forEach(year => this.years.push(currentYear + year))

    this.viewing = {
      day: now.date(),
      month: now.month(),
      year: now.year()
    }

    this.localValue = {
      day: this.value.date(),
      month: this.value.month(),
      year: this.value.year()
    }
  },
  data () {
    return {
      localValue: {},
      viewing: {},
      years: []
    }
  },
  methods: {
    addMonths (n) {
      this.viewing.month += n

      if (this.viewing.month > 11) {
        this.viewing.month = 0
        this.viewing.year++
      }

      if (this.viewing.month < 0) {
        this.viewing.month = 11
        this.viewing.year--
      }
      this.$emit('input', moment(`${this.localValue.year}-${this.viewing.month + 1}-${this.localValue.day}`, 'YYYY-MM-DD'))
    },
    closeEvent () {
      if (this.open) {
        this.open = false
      }
    },
    getClasses (day) {
      return {
        'slds-disabled-text': day.month() !== this.viewing.month || this.disabled,
        'slds-is-selected': !this.disabled && day.date() === this.localValue.day && day.month() === this.localValue.month && this.localValue.year === this.viewing.year
      }
    },
    goToDate (day) {
      this.$emit('changeDate', { day })
    },
    selectDay (day) {
      this.localValue = {
        day,
        month: this.viewing.month,
        year: this.viewing.year
      }

      this.$emit('input', moment(`${this.localValue.year}-${this.localValue.month + 1}-${this.localValue.day}`, 'YYYY-MM-DD'))
    },
    today () {
      const now = moment()

      this.localValue = {
        day: now.date(),
        month: now.month(),
        year: now.year()
      }

      this.$emit('input', moment(`${this.localValue.year}-${this.localValue.month + 1}-${this.localValue.day}`, 'YYYY-MM-DD'))

      this.viewing = {
        day: now.date(),
        month: now.month(),
        year: now.year()
      }
    },
    toggleOpen () {
      this.open = !this.open
    }
  },
  props: {
    disabled: Boolean,
    label: String,
    value: Object
  },
  watch: {
    value (value) {
      this.localValue = {
        day: value.date(),
        month: value.month(),
        year: value.year()
      }

      this.viewing = {
        day: value.date(),
        month: value.month(),
        year: value.year()
      }
    }
  }
}
</script>
